import { jwtDecode } from "jwt-decode";

function getUniqueListBy(arr, key) {
  return [...new Map(arr?.map((item) => [item[key], item])).values()];
}

function currencyFormat(num) {
  return num?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function detailPageURL(MachineDetails) {
  const URL = `${MachineDetails?.year}-${MachineDetails?.model?.manufacturer?.name}-${MachineDetails?.model?.number}${MachineDetails?.unit_number ? `-${MachineDetails?.unit_number}` : ``
    }`;

  const encodeURICom = encodeURIComponent(URL);
  const RPath = `/detail/${MachineDetails?.category?.name.replace(/ /g, "-")}/${encodeURICom}-${MachineDetails?.id}`;
  return RPath;
}

function detailSideBarPageURL(MachineDetails) {
  const URL = `${MachineDetails?.Year}-${MachineDetails?.Model}-${MachineDetails?.MakeName}${MachineDetails?.UnitNumber ? `-${MachineDetails?.UnitNumber}` : ``
    }`;

  const encodeURICom = encodeURIComponent(URL);
  const RPath = `/detail/${MachineDetails?.CompanyName.replace(/ /g, "-")}/${encodeURICom}-${MachineDetails?.id}`;
  return RPath;
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function cleanObjectKeys(obj) {
  const prefix = "extension_"; // The static part of the prefix
  const cleanedObj = {};

  Object.keys(obj).forEach((key) => {
    if (key.startsWith(prefix)) {
      const newKey = key.replace(/^extension_[^_]*_/, ""); // Remove "extension_" and the dynamic part
      cleanedObj[newKey] = obj[key];
    } else {
      cleanedObj[key] = obj[key]; // Preserve keys without the prefix
    }
  });

  return cleanedObj;
}

function base64ToBlob(base64) {
  const mimeType = base64.split(";")[0].split(":")[1]; // Extract the mime type from the base64 string
  const byteString = atob(base64.split(",")[1]); // Decode Base64 string
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeType });
}

function fileToBlob(file) {
  // The file type (MIME type) is directly available from the file object
  const mimeType = file.type;
  return new Blob([file], { type: mimeType });
}

function logoutFun() {
  localStorage.removeItem("vizy-identity-token");
  localStorage.removeItem("vizy-identity-refresh-token");
  localStorage.removeItem("vizy-bility-token");
  localStorage.removeItem("vizy-refresh-token");
  localStorage.removeItem("client_info");
  localStorage.removeItem("vizy-azure-token");
  localStorage.removeItem("getAzureUserData");
  localStorage.removeItem("azuretoken");
  localStorage.removeItem("OpenWarning");
  window.location.href = "/";
}

const parseHtmlToText = (htmlString) => {
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

const isAzureTokenValid = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    if (decoded.exp && decoded.exp < currentTime) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export {
  getUniqueListBy,
  currencyFormat,
  detailPageURL,
  detailSideBarPageURL,
  formatDate,
  addDays,
  cleanObjectKeys,
  base64ToBlob,
  fileToBlob,
  logoutFun,
  parseHtmlToText,
  isAzureTokenValid,
};
